import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'footer-area-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: false
})
export class FooterAreaPrivacyComponent implements OnInit {

  constructor(
    public translateService: TranslateService,
  ) {}

  ngOnInit(): void { }
}
